import {Injectable, Injector} from '@angular/core';
import {Observable} from 'rxjs';


import {Company} from '../../models/lookups/company';
import {BaseService} from '../base/base.service';
import {Query} from '../../models/query/query';
import {WebMethodResult} from '../../models/web-method-result';
import {AppModulePath} from '../../models/app-module-path';
import {HttpClient} from '@angular/common/http';
import {PlatformLocation} from '@angular/common';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class CompanyService extends BaseService {
  private listUrl = '/api/companies/list';
  private listExtendedUrl = '/api/companies/listWithCity';
  private countUrl = '/api/companies/count';
  private postUrl = '/api/companies/save';
  private deleteUrl = '/api/companies/delete/';
  private qryUrl = '/api/companies/sendQuery';

  constructor(protected injector: Injector,
              protected http2: HttpClient,
              protected platformLocation: PlatformLocation) {
    super(injector, http2, platformLocation);
  }

  list(qry: Query): Observable<Company[]> {
    const url = this.listUrl + '?q=' + encodeURIComponent(JSON.stringify(qry));
    return this.get<Company[]>(url, AppModulePath.COMPANY).pipe(
      map(res => res.map(obj => new Company(obj))),
      catchError(this.handleError));
  }

   listWithCity(qry: Query): Observable<Company[]> {
    const url = this.listExtendedUrl + '?q=' + encodeURIComponent(JSON.stringify(qry));
    return this.get<Company[]>(url, AppModulePath.COMPANY).pipe(
      map(res => res.map(obj => new Company(obj))),
      catchError(this.handleError));
  }

  count(): Observable<number> {
    return this.get<number>(this.countUrl, AppModulePath.COMPANY).pipe(
      map(res => res),
      catchError(this.handleError));
  }

  save(company: Company): Observable<Company> {
    return this.post(this.postUrl, AppModulePath.COMPANY, company).pipe(
      map(res => new Company(res)),
      catchError(this.handleError));
  }

  delete(id: String): Observable<WebMethodResult> {
    return this._delete<WebMethodResult>(this.deleteUrl + id, AppModulePath.COMPANY).pipe(
      map(res => new WebMethodResult(res)),
      catchError(this.handleError));
  }
}
